import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import { ContentZonesService } from '@sm360/widget-commons-core-services';

import CashPayment from 'commons-vehicle/Vehicle/components/Payment/CashPayment/CashPayment.jsx';
import Financing from 'commons-vehicle/Vehicle/components/Payment/Financing/Financing.jsx';
import Price from 'commons-vehicle/Vehicle/components/Payment/Price/Price.jsx';
import PaymentDetailRebate from 'commons-vehicle/Vehicle/components/Payment/PaymentDetail/PaymentDetailRebate.jsx';
import PURCHASE_METHODS from 'commons-vehicle/PurchaseMethods/constants/purchaseMethodsValues.js';

const PaymentDetail = ({ purchaseMethods, forcedPurchaseMethod, isUsed, taxCodes }) => {
    const currentMethod = forcedPurchaseMethod || purchaseMethods.getSelectedPurchaseMethodValue();
    const cashPurchaseObject = purchaseMethods.getSelectedPurchaseMethodAmounts();

    const tradeIn = cashPurchaseObject.tradeIn > 0 && (
        <PaymentDetailRebate
            amount={cashPurchaseObject.tradeIn}
            i18nKey="PAYMENTS_REBATES.TRADEIN"
            data={{ 'data-sr': 'TradeIn' }}
            iconClass="icon-refresh"
        />
    );

    const modelElectricRebate = purchaseMethods.cashPurchase.getElectricRebate();
    const isThereElectricRebate =
        !isEmpty(modelElectricRebate) && !!modelElectricRebate.rebate && !Number.isNaN(modelElectricRebate.rebate);
    const electricRebate = isThereElectricRebate && (
        <PaymentDetailRebate
            amount={modelElectricRebate.rebate}
            i18nKey="PAYMENTS_REBATES.ELECTRIC_REBATE"
            data={{ 'data-sr': 'ElectricRebate' }}
            iconClass="icon-electric-vehicle"
        />
    );

    let paymentMethod = null;
    if (currentMethod === PURCHASE_METHODS.FINANCE || currentMethod === PURCHASE_METHODS.LEASE) {
        paymentMethod = (
            <Financing purchaseMethods={purchaseMethods} taxCodes={taxCodes} isUsed={isUsed}>
                {tradeIn}
                {electricRebate}
            </Financing>
        );
    } else if (currentMethod === PURCHASE_METHODS.CASH) {
        const { disclaimers } = purchaseMethods;
        const taxesExcludedDisclaimer = disclaimers ? disclaimers.taxesExcluded : '';
        const cashPurchaseAmounts = purchaseMethods.getCashPurchaseAmounts();

        const includedDisclaimerCzLocation = isUsed
            ? 'disclaimer.price.included.used.cash'
            : 'disclaimer.price.included.new';
        const includedDisclaimer = ContentZonesService.getContentZone('widget.commons', includedDisclaimerCzLocation)
            ? ContentZonesService.getContentZone('widget.commons', includedDisclaimerCzLocation).getValue()
            : '';

        const rebatesAmount = isThereElectricRebate
            ? cashPurchaseAmounts.rebates - modelElectricRebate.rebate
            : cashPurchaseAmounts.rebates;

        const rebates = rebatesAmount > 0 && (
            <PaymentDetailRebate
                amount={rebatesAmount}
                i18nKey={isUsed ? 'PAYMENTS_REBATES.USED_REBATE' : 'PAYMENTS_REBATES.MANUFACTURER_REBATE'}
                data={{ 'data-sr': 'Rebate' }}
                iconClass="icon-promo2"
            />
        );

        const dealerRebates = cashPurchaseAmounts.dealerDiscounts > 0 && (
            <PaymentDetailRebate
                amount={cashPurchaseAmounts.dealerDiscounts}
                i18nKey="PAYMENTS_REBATES.DEALER_REBATE"
                data={{ 'data-sr': 'Rebate' }}
                iconClass="icon-promo2"
            />
        );

        paymentMethod = (
            <div className="payment-summary-section">
                <CashPayment
                    isUsed={isUsed}
                    msrp={purchaseMethods.cashPurchase.getRetail() + cashPurchaseAmounts.dealerDiscounts}
                >
                    {includedDisclaimer && (
                        <span className="payment-row disclaimer is-light sr-text">{includedDisclaimer}</span>
                    )}
                    <div className="payment-rebates">
                        {rebates}
                        {dealerRebates}
                        {electricRebate}
                    </div>
                </CashPayment>
                <Price
                    amount={purchaseMethods.cashPurchase.getRetail() - purchaseMethods.cashPurchase.getTotalRebates()}
                    taxCodes={taxCodes}
                    taxesExcludedDisclaimer={taxesExcludedDisclaimer}
                />
            </div>
        );
    }
    return paymentMethod;
};

PaymentDetail.defaultTypes = {
    forcedPurchaseMethod: null,
};

PaymentDetail.propTypes = {
    purchaseMethods: PropTypes.shape({
        cashPurchase: PropTypes.object.isRequired,
        financing: PropTypes.object.isRequired,
    }).isRequired,
    forcedPurchaseMethod: PropTypes.string,
    isUsed: PropTypes.bool.isRequired,
    taxCodes: PropTypes.string.isRequired,
};

PaymentDetail.displayName = 'PaymentDetail';

export default PaymentDetail;



// WEBPACK FOOTER //
// ./src/Vehicle/components/Payment/PaymentDetail/PaymentDetail.jsx